<h1>Weather forecast</h1>

<p>This component demonstrates fetching data from the server.</p>
<div>
  <label>Summary: </label>
  <select (change)="filterForeCasts($event.target.value)">
    <option value="0">--All--</option>
    <option *ngFor="let summary of summaries" value={{summary}}>
      {{summary}}
    </option>
  </select>
</div>

<p *ngIf="!forecasts"><em>Loading...</em></p>

<table class='table' *ngIf="forecasts">
  <thead>
    <tr>
      <th>Date</th>
      <th>Temp. (C)</th>
      <th>Temp. (F)</th>
      <th>Summary</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let forecast of forecasts">
      <td>{{ forecast.dateFormatted }}</td>
      <td>{{ forecast.temperatureC }}</td>
      <td>{{ forecast.temperatureF }}</td>
      <td>{{ forecast.summary }}</td>
    </tr>
  </tbody>
</table>
